<template>
  <div>
    <n-bread
        v-bind:content="{bread_list, bread_active}"
    ></n-bread>
    <div class="card   abtg__default-card abtg__default-card-border">

      <div class="card-body ">
        <h3>Le caratteristiche del servizio</h3>
        <p>
          Questo servizio permette di recuperare le informazioni registrate presso il catasto relativamente ad un
          immobile (fabbricato o terreno). In particolare presenta le seguenti informazioni:
        </p>
        <ul>
          <li>
            i dati identificativi e reddituali dei beni immobili (zona censuaria, categoria, classe, consistenza e
            rendita)
          </li>
        </ul>

        <h3>Costi</h3>
        <p>Il costo del servizio è pari ai <strong>risultati ottenuti</strong>: questo significa che il wallet digitale
          a tua disposizione scalerà i crediti quando richiederai la visura catastale.<br>
          Il costo di ogni singolo risultato è di <strong>n. {{price}} crediti</strong>.</p>

        <span >
        <a href="/services/catasto" class="text-center mt-2 btn btn-success abtg__btn-third shadow-none abtg-button-big">ACCEDI AL SERVIZIO</a>
        </span>

      </div>
    </div>
  </div>
</template>

<script>
import NBread from '@/partials/bread';
import {mapActions, mapState, mapMutations} from 'vuex';

export default {
  components: {
    NBread
  },
  computed: {
    ...mapState('n_catasto', ['bread_active', 'bread_list', 'price']),
  },

  created() {
    this.SET_DATA({name: 'bread_active', data: {label: 'Servizio di visure catastali'}});
    this.getPrice();
  },
  methods: {
    ...mapActions('n_catasto', ['getPrice']),
    ...mapMutations('n_catasto', ['SET_DATA']),
  }
}
</script>
